import axios from 'axios'
import {DataArrayResponse,PageResponse} from '../models/PageResponse'
import { Emailsetting} from '../models/'
import { config } from '../config'
import { CookieHelper } from '../helpers'

const apiUrl = config.API_URL
const version = 1

export default class EmailSettingService
{
    protected headers = {}
 protected token = ""

    constructor(token:string | null){
        if(token){
            this.token = token
            this.headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            }
        }
        
    }
    
    async getAll(){
            if(Object.keys(this.headers).length === 0 ) return null

            let options = {
                headers: this.headers
            }
        
            const response = await axios.get<DataArrayResponse<Emailsetting>>(`${apiUrl}/v${version}/emailsettings/call?`, options )
            return response.data;
        
    }

    async UpdateEmailSetting(emailsettings: Emailsetting[]){
        let xsrfToken = await CookieHelper.getCookie(this.token)
        this.headers['X-XSRF-TOKEN'] = xsrfToken
        let options = {
            headers: this.headers
        }
        const { data }  = await axios.put<PageResponse>(`${apiUrl}/v1/emailsettings/call`,JSON.stringify(emailsettings),options )
        return data;
    }

}